import Compare from "../marketing/Compare";

export default function CompareWhoBrewVsLinq() {
  return (
    <Compare
      competitor="Linq"
      path="/compare/whobrew-vs-linq"
      seoTitle="WhoBrew vs Linq — NFC business card comparison"
      seoDescription="WhoBrew compared to Linq. Pricing, features, and where each one fits. No spin."
      positioning="Linq is an affordable, broad-audience NFC card with a wide catalog of card materials and persona-by-vertical positioning. WhoBrew sits in similar territory with tighter focus on the surfaces a card-using person actually touches every week."
      wedge={{
        headline: "A focused product, not a SaaS sampler",
        italicWord: "focused",
        subhead:
          "Linq covers many things at low prices. The trade-off shows: themes feel templated, the editor is workmanlike, the analytics surface is generic. It's a product optimized for category coverage, not depth on any one thing. WhoBrew picks fewer fights and wins them. The card editor, the contact form, the leads inbox — these are the surfaces a card-using person uses every week, and we invest there. $2 more per month is the price of that focus.",
      }}
      outcomeStats={[
        {
          label: "Time to first live card",
          whobrew: "60s",
          competitor: "~5 min",
          context: "Sign up, claim handle, ship card.",
        },
        {
          label: "Custom form fields",
          whobrew: "Up to 4 per link",
          competitor: "Standard fields",
          context: "Per-persona qualifying questions on Pro.",
        },
        {
          label: "Per-link source attribution",
          whobrew: "Surfaced in /leads",
          competitor: "Not surfaced",
          context: "Know which event drove which lead.",
        },
      ]}
      rows={[
        { feature: "Free tier",            whobrew: "Free forever",  competitor: "Limited free" },
        { feature: "Starting paid plan",   whobrew: "$4.99 / month", competitor: "$2.99 / month" },
        { feature: "NFC card",             whobrew: "$14.99 once",   competitor: "$12.99–$45" },
        { feature: "Lead capture",         whobrew: true,            competitor: true },
        { feature: "Custom contact-form fields", whobrew: "Up to 4 per link (Pro)", competitor: "Limited" },
        { feature: "Per-link source attribution", whobrew: true,     competitor: false },
        { feature: "Per-link analytics",   whobrew: true,            competitor: true },
        { feature: "Custom themes",        whobrew: "11 included",   competitor: "Limited" },
        { feature: "Editor depth",         whobrew: "First-class",   competitor: "Workmanlike" },
      ]}
      whereTheyWin="Linq is competitive on raw price for the physical card and has a wide catalog of card materials, including metal and wooden options at higher tiers. If your priority is the cheapest paid plan possible or you specifically want a metal card, Linq is worth a look."
      recommendation="Pick Linq if rock-bottom paid pricing or premium card materials are the deciding factor. Pick WhoBrew if you'd rather pay $2 more a month for a tighter editor, a smarter contact form, and per-link source attribution that actually shows up in your leads inbox."
    />
  );
}
